import React from "react";
import "./ui.css";
import star from "../../assets/star.png";
import { Btn } from "../../utils/utils";
import agent from "../../assets/agent-pic.png";

const EachAgent = ({agentData}) => {
  const starImg = [star, star, star, star, star];
  // console.log(agentData);
  

  return (
    <div className="each-agent">
      <img src={!agentData?.picture ? agent : agentData?.picture} alt="agent" />
      <h3>{agentData?.name}</h3>
      <div className="hhr-img">
        <div className="hrr-img_img">
          {starImg.slice(0, agentData?.ratingCount).map((item, i) => {
            return <img key={i} src={item} alt="star" />;
          })}
        </div>
        <p>{agentData?.ratingCount} ({agentData?.totalRatings} Reviews)</p>
      </div>
      <div className="btn-location">
        <Btn btnLink={"/agents"} btnClass={"home-btn"} btnText={`${agentData?.propertyCount} Listings`}  />
        {/* <p><Location /> {location}</p> */}
      </div>
    </div>
  );
};

export default EachAgent;
